export default __webpack_public_path__ + "static/media/bg_feedback.d173304a.svg";